import { Link } from 'react-router-dom';
import { brand } from '../../data/content';
import './Footer.css';

const links = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/fernandomacedoborelli' },
  { label: 'E-mail', href: 'mailto:fernandomacedoborelli@gmail.com' },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="footer-logo">{brand.name}</span>
          <p>{brand.subtitle}</p>
        </div>

        <div className="footer-nav">
          <Link to="/casos">Casos</Link>
          <Link to="/#automacao-n8n">N8N e IA</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/sobre">Sobre</Link>
          <Link to="/diagnostico">Diagnóstico</Link>
          <Link to="/contato">Contato</Link>
          <Link to="/portal">Portal do Cliente</Link>
        </div>

        <div className="footer-links">
          {links.map((link) => (
            <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer">
              {link.label}
            </a>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {year} {brand.name} — Fernando Borelli</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
